import { ref } from 'vue';
import { randomString } from 'cesg-shared/dist/utils';

class AppService {
  readonly rootAppKey = ref('');

  reload() {
    this.rootAppKey.value = randomString();
  }
}

export const appService = new AppService();
